export default function groupDataSelector(func) {
  return func((state) => state.groupsReducer);
}
